var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-toolbar",
        {
          attrs: { color: "primary", app: "", dark: "", extended: _vm.extended }
        },
        [
          _c("v-toolbar-side-icon", {
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toggleDrawer.apply(null, arguments)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "v-toolbar-title",
            [
              !_vm.loading
                ? [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c("v-toolbar-items", [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.extended
            ? _c(
                "template",
                { slot: "extension" },
                [
                  _vm._t("extension", function() {
                    return [_vm._v("default extended")]
                  })
                ],
                2
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021887fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021887fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = null
// module chunks = 